import { useContext } from 'react';
import { UserContext } from '../Context/Usercontext';

export const useRoleBasedRoute = () => {
  const { userRole } = useContext(UserContext);
  
  const getRoute = (path) => {
    if (userRole === 'admin') {
      return path === "" ? "/" : `/${path}`;
    } else if (userRole === 'moderator') {
      return path === "" ? "/moderator" : `/moderator/${path}`;
    } else if (userRole === 'teacher') {
      return path === "" ? "/teacher" : `/teacher/${path}`;
    }
    else if (userRole === 'modulemoderator') {
      return path === "" ? "/modulemoderator" : `/modulemoderator/${path}`;
    }
    return path === "" ? "/" : `/${path}`; // fallback
  };
  
  return { getRoute };
}; 